module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么部分组件要加"), _c('code', [_vm._v("x-")]), _vm._v("前缀")]), _vm._v(" "), _c('p', [_vm._v("若不更名，可能在开发时与标准 html 标签相同而导致冲突或者 bug，比如 "), _c('code', [_vm._v("Dialog")]), _vm._v(", "), _c('code', [_vm._v("Switch")]), _vm._v(" 等。从Vue@2.x开始已经强制不能使用原生html标签。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b0e1944", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4b0e1944"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/why-use-x-prefix-for-components-31.vue
// module id = 2707
// module chunks = 186